import type { ChartWrapperPadding } from './ChartWrapper'

export const ChartWrapperConstants = {
  defaultHeightPx: 300,
  topPadding: 8,
  rightPadding: 16,
  minLeft: 8,
  minBottom: 8,
  /** Baseline padding used by setup before render-time chrome measurement. */
  baselinePadding: {
    top: 8,
    right: 16,
    left: 48,
    bottom: 32,
  } satisfies ChartWrapperPadding,
  tickFont: '500 10px Montserrat, sans-serif',
  axisLabelFont: '500 10px Montserrat, sans-serif',
  axisLabelFontSize: 10,
  tickFontSize: 10,
  yTickMargin: 7,
  yLabelGap: 12,
  xTickGap: 5,
  xLabelGap: 12,
  /**
   * Extra room below the X-axis title baseline. VisX `@visx/text` defaults to
   * verticalAnchor "end" with startDy 0, so `y` is the alphabetic baseline and
   * descenders (e.g. the "y" in "Category") extend past fontSize.
   */
  axisLabelDescenderPad: 4,
  /**
   * Initial width before the first positive ResizeObserver measure.
   * Transient 0s (e.g. portal reparent) must not snap to this — Wrapper
   * keeps the last positive width instead.
   */
  fallbackWidthPx: 640,
  /**
   * Fallback when bandPack is absent: grouped vertical clusters.
   */
  verticalBandPaddingInner: 0.45,
  verticalBandPaddingOuter: 0.02,
  /**
   * Fallback when bandPack is absent: fill the plot; 12px bars stay
   * centered in each band via barRect.
   */
  horizontalBandPaddingInner: 0,
  horizontalBandPaddingOuter: 0,
  /**
   * Extra left room so canvas-measured tick widths (Montserrat may still be
   * loading) do not clip long category labels such as "Puerto Cortes".
   */
  yTickLabelOverflowPad: 8,
}
